/**
 * @Description: 耗材的纸带颜色信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  PaperColorDefModel,
  PaperColorDefSearchModel,
  PaperColorDefPageSearchModel,
  PaperColorDefAddModel,
  PaperColorDefUpdateModel,
  IdsModel
} from '@/model/product/PaperColorDefModel'

const baseUrl = Route.product + '/paperColorDef'

/**
 * 搜索分页数据
 */
export const pageSearchPaperColorDef = (param: PaperColorDefPageSearchModel) => {
  return https().request<RootObject<PageRespModel<PaperColorDefModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchPaperColorDef = (param: PaperColorDefSearchModel) => {
  return https().request<RootObject<PaperColorDefModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getPaperColorDef = (id: number) => {
  return https().request<RootObject<PaperColorDefModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addPaperColorDef = (param: PaperColorDefAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updatePaperColorDef = (param: PaperColorDefUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removePaperColorDef = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemovePaperColorDef = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
